
// Server API URL
 export const API_URL = 'https://sgt-api.austere.biz/'


// Local API URL
// export const API_URL = 'http://localhost:4005/'


